import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminGridComponent, GridColumn } from 'src/app/components/layout/admin-grid/admin-grid.component';
import { AccountService } from 'src/app/services/account.service';
import { Account } from 'src/app/models/account.model';

@Component({
  selector: 'app-account-manager',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminGridComponent],
  templateUrl: './account-manager.component.html',
  styleUrls: ['./account-manager.component.scss']
})
export class AccountManagerComponent implements OnInit {
  user = {
    picture: '/assets/images/avatar.png',
    nickname: 'Admin',
    email: 'admin@bouncd.com'
  };

  accounts: Account[] = [];
  loading = false;

  columns: GridColumn[] = [
    { field: 'name', header: 'Account Name', sortable: true },
    { field: 'email', header: 'Email', sortable: true },
    { field: 'phone', header: 'Phone', sortable: true },
    { field: 'subscriptionTier', header: 'Tier', sortable: true },
    { field: 'sites', header: 'Sites' },
    { field: 'createdAt', header: 'Created', sortable: true },
    { field: 'updatedAt', header: 'Updated', sortable: true }
  ];

  constructor(private accountService: AccountService) {}

  ngOnInit(): void {
    this.loadAccounts();
  }

  /** Metrics */
  get totalUserCount(): number {
    return 0; // placeholder until user-account linking is added
  }

  get totalSiteCount(): number {
    return this.accounts.reduce((acc, a) => acc + (a.sites?.length || 0), 0);
  }

  /** Load accounts */
  loadAccounts(): void {
    this.loading = true;
    this.accountService.getAll().subscribe({
      next: (data) => {
        // Map sites array for display (string list)
        this.accounts = data
          .map((a) => ({
            ...a,
            sites: Array.isArray(a.sites) ? a.sites : []
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load accounts:', err);
        this.loading = false;
      }
    });
  }

  /** Open account details */
  openAccount(row: Account): void {
    console.log('Open account details', row);
  }

  /** Create new account (fills all fields) */
  addAccount(): void {
    const newAccount: Account = {
      id: crypto.randomUUID(),
      name: 'New Account',
      email: 'new@account.com',
      phone: '(555) 000-0000',
      subscriptionTier: 'free',
      sites: ['example.com', 'staging.example.com'],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    this.accountService.create(newAccount).subscribe({
      next: () => this.loadAccounts(),
      error: (err) => console.error('Failed to add account:', err)
    });
  }

  /** Edit existing account (updates timestamp and allows full field coverage) */
  editAccount(row: Account): void {
    const updated: Partial<Account> = {
      ...row,
      name: `${row.name} (Updated)`,
      updatedAt: new Date().toISOString()
    };

    this.accountService.update(row.id, updated).subscribe({
      next: () => this.loadAccounts(),
      error: (err) => console.error('Failed to update account:', err)
    });
  }

  /** Delete account */
  deleteAccount(row: Account): void {
    if (!confirm(`Delete account "${row.name}"?`)) return;

    this.accountService.delete(row.id).subscribe({
      next: () => this.loadAccounts(),
      error: (err) => console.error('Failed to delete account:', err)
    });
  }
}